import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getTaskCommentsQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { CreateComment } from "../types/Comment";
import { createComment } from "./comments.service";

export const useCreateComment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (comment: CreateComment) => createComment(comment),
    onSuccess: (comment) => {
      return queryClient.invalidateQueries({
        queryKey: getTaskCommentsQueryKey(comment.task_id),
      });
    },
  });
};
